export default function SearchIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 21) / 20)}
        viewBox='0 0 20 21'
        fill='currentColor'
      >
        <path d='M9.1665 3.83366C5.94484 3.83366 3.33317 6.44533 3.33317 9.66699C3.33317 12.8887 5.94484 15.5003 9.1665 15.5003C12.3882 15.5003 14.9998 12.8887 14.9998 9.66699C14.9998 6.44533 12.3882 3.83366 9.1665 3.83366ZM1.6665 9.66699C1.6665 5.52486 5.02437 2.16699 9.1665 2.16699C13.3086 2.16699 16.6665 5.52486 16.6665 9.66699C16.6665 13.8091 13.3086 17.167 9.1665 17.167C5.02437 17.167 1.6665 13.8091 1.6665 9.66699Z' />
        <path d='M13.2856 13.7861C13.611 13.4606 14.1387 13.4606 14.4641 13.7861L18.0891 17.4111C18.4145 17.7365 18.4145 18.2641 18.0891 18.5896C17.7637 18.915 17.236 18.915 16.9106 18.5896L13.2856 14.9646C12.9601 14.6391 12.9601 14.1115 13.2856 13.7861Z' />
      </svg>
    </span>
  );
}
